import {
  STOCK_STOCKS_PRODUCTO_BEGIN,
  STOCK_STOCKS_PRODUCTO_SUCCESS,
  STOCK_STOCKS_PRODUCTO_FAILURE,
  STOCK_STOCKS_PRODUCTO_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export function stocksProducto({ idProducto, filter }) {
  return (dispatch) => {
    dispatch({
      type: STOCK_STOCKS_PRODUCTO_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {

      //Acá va la llamada con axios
      const doRequest = axios(CATALOGO_ENDPOINT + `/${idProducto}/stocks?${filter}`)

      doRequest.then(
        (res) => {
          dispatch({
            type: STOCK_STOCKS_PRODUCTO_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: STOCK_STOCKS_PRODUCTO_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissStocksProductoError() {
  return {
    type: STOCK_STOCKS_PRODUCTO_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_STOCKS_PRODUCTO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        stocksProductoPending: true,
        stocksProductoError: null,
      };

    case STOCK_STOCKS_PRODUCTO_SUCCESS:
      // The request is success
      return {
        ...state,
        stocksProductoData: action.data.data,
        stocksProductoPagination: action.data.pagination,
        stocksProductoPending: false,
        stocksProductoError: null,
      };

    case STOCK_STOCKS_PRODUCTO_FAILURE:
      // The request is failed
      return {
        ...state,
        stocksProductoPending: false,
        stocksProductoError: action.data.error,
      };

    case STOCK_STOCKS_PRODUCTO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        stocksProductoError: null,
      };

    default:
      return state;
  }
}
